import angular from 'angular';
import AttributeModalComponent from './attribute.modal.component';
export default angular.module('inv.customer.orderHistory.orderDetails.attributeModal', []).component('attributeModal', AttributeModalComponent).name;